module.exports = __webpack_public_path__ + "img/ic-nav-classic--next-circle-white.9da6007f.svg";